import { Link } from "react-router-dom";
import { ChevronDown } from "lucide-react";
import { UserRound, LogOut } from "lucide-react";
import dummyUser from "../../assets/images/dummyUser.svg";
import useImageUrl from "../../CustomHooks/useImageUrl";
import LogoutAction from "../../components/auth/LogoutAction";

const UserProfile = () => {
  const { getImageUrl } = useImageUrl();
  const profilePic = localStorage.getItem("profilePic");
  const userName = localStorage.getItem("userName");

  return (
    <>
      <div className="group profileDropdown-wrap">
        <img
          src={profilePic ? getImageUrl(profilePic) : dummyUser}
          alt="profileImg"
          className="w-8 h-8 rounded-full"
        />
        <p className="usernameText">{userName}</p>
        <ChevronDown color="white" className="profile-dropdown-arr" />
        <div className="group-hover:opacity-100 group-hover:visible show-dropdown-wrap">
          <Link
            to="/profile"
            className="py-3 dropdown-link hover:text-blue-50 text-gray-500"
          >
            <UserRound className="mr-1" />
            View Profile
          </Link>
          <LogoutAction>
            {({ onLogout, loading }) => (
              <button
                className="pb-3 dropdown-link hover:text-blue-50 text-gray-500"
                onClick={onLogout}
                disabled={loading}
              >
                <LogOut className="mr-1" />
                {loading ? "Logging out..." : "Logout"}
              </button>
            )}
          </LogoutAction>
        </div>
      </div>
    </>
  );
};

export default UserProfile;
